import React from 'react'
import Cookies from 'js-cookie';
import NavigationCards from './navigationCards';

function AccountHome() {
  const currentTime = new Date();
  let currentHour = currentTime.getHours();

  // Convert to 24-hour format if necessary
  if (currentHour > 12) {
    currentHour -= 12;
  }

  let greeting;

  if (currentHour < 12) {
    greeting = 'Good morning';
  } else if (currentHour < 18) {
    greeting = 'Good afternoon';
  } else {
    greeting = 'Good evening';
  }

  const userfullname = Cookies.get("userfullname")
  console.log(userfullname)
  return (
    <div className='accountForms'>
      <div class="md:items-center md:flex">
        <p class="text-base font-bold text-gray-900 greetingText">{greeting}</p>
        <p class="mt-1 text-base font-medium text-gray-500 md:mt-0 md:ml-2">{userfullname}</p>
      </div>

      <NavigationCards />
    </div>
  )
}

export default AccountHome